/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GoalTypeAmountList } from '../models/GoalTypeAmountList';
import type { PlayerStatisticsListV2 } from '../models/PlayerStatisticsListV2';
import type { PlayerStatisticsV2 } from '../models/PlayerStatisticsV2';
import type { StatisticCenter } from '../models/StatisticCenter';
import type { StatisticKeyEnum } from '../models/StatisticKeyEnum';
import type { TeamStatisticsListV2 } from '../models/TeamStatisticsListV2';
import type { TeamStatisticsV2 } from '../models/TeamStatisticsV2';
import type { TopScorer } from '../models/TopScorer';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StatisticsService {
    /**
     * Get Player Statistics
     * @param teamId
     * @param leagueId
     * @param limit
     * @returns PlayerStatisticsListV2 Successful Response
     * @throws ApiError
     */
    public static getPlayerStatisticsStatisticsV2PlayerGet(
        teamId?: (number | null),
        leagueId?: (number | null),
        limit?: (number | null),
    ): CancelablePromise<PlayerStatisticsListV2> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/statistics/v2/player',
            query: {
                'team_id': teamId,
                'league_id': leagueId,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Player Statistics By Key
     * @param key
     * @param limit
     * @param offset
     * @param leagueId
     * @param teamId
     * @returns PlayerStatisticsV2 Successful Response
     * @throws ApiError
     */
    public static getPlayerStatisticsByKeyStatisticsV2PlayerSingleGet(
        key: StatisticKeyEnum,
        limit: number,
        offset: number,
        leagueId: number,
        teamId?: (number | null),
    ): CancelablePromise<PlayerStatisticsV2> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/statistics/v2/player/single',
            query: {
                'key': key,
                'limit': limit,
                'offset': offset,
                'league_id': leagueId,
                'team_id': teamId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Team Top Player
     * @param teamId
     * @param amountMatches
     * @param leagueId
     * @returns PlayerStatisticsListV2 Successful Response
     * @throws ApiError
     */
    public static getTeamTopPlayerStatisticsV2PlayerTopTeamTeamIdGet(
        teamId: number,
        amountMatches: number,
        leagueId?: (number | null),
    ): CancelablePromise<PlayerStatisticsListV2> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/statistics/v2/player/top/team/{team_id}',
            path: {
                'team_id': teamId,
            },
            query: {
                'amount_matches': amountMatches,
                'league_id': leagueId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Team Goals
     * @param teamId
     * @param leagueId
     * @returns GoalTypeAmountList Successful Response
     * @throws ApiError
     */
    public static getTeamGoalsStatisticsV2GoalsTeamTeamIdGet(
        teamId: number,
        leagueId?: (number | null),
    ): CancelablePromise<GoalTypeAmountList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/statistics/v2/goals/team/{team_id}',
            path: {
                'team_id': teamId,
            },
            query: {
                'league_id': leagueId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Center Statistics
     * @returns StatisticCenter Successful Response
     * @throws ApiError
     */
    public static getCenterStatisticsStatisticsV2CenterGet(): CancelablePromise<StatisticCenter> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/statistics/v2/center',
        });
    }
    /**
     * Get Team Statistics
     * @param leagueId
     * @param limit
     * @returns TeamStatisticsListV2 Successful Response
     * @throws ApiError
     */
    public static getTeamStatisticsStatisticsV2TeamGet(
        leagueId: number,
        limit?: (number | null),
    ): CancelablePromise<TeamStatisticsListV2> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/statistics/v2/team',
            query: {
                'league_id': leagueId,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Team Statistics By Key
     * @param key
     * @param limit
     * @param offset
     * @param leagueId
     * @returns TeamStatisticsV2 Successful Response
     * @throws ApiError
     */
    public static getTeamStatisticsByKeyStatisticsV2TeamSingleGet(
        key: StatisticKeyEnum,
        limit: number,
        offset: number,
        leagueId: number,
    ): CancelablePromise<TeamStatisticsV2> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/statistics/v2/team/single',
            query: {
                'key': key,
                'limit': limit,
                'offset': offset,
                'league_id': leagueId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Top Scorer
     * @param matchId
     * @returns TopScorer Successful Response
     * @throws ApiError
     */
    public static getTopScorerStatisticsV2TopScorerMatchIdGet(
        matchId: number,
    ): CancelablePromise<TopScorer> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/statistics/v2/top_scorer/{match_id}',
            path: {
                'match_id': matchId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
